const Auxilary = (props) => props.children;

export default Auxilary;